Ext.define('SA.view.Grid', {
    alias: 'widget.sa-grid',
    extend: 'Ext.Component',

    baseCls: 'sa-grid',
    rowHeight: 48,

    childEls: [
        'inner',
            'header',
                'lockedHeader',
                'normalHeader',
                    'headerScroll',
            'body',
                'lockedWrap',
                    'lockedTable',
                        'lockedTableBody',
                'normalWrap',
                    'normalTable',
                        'tableBody',
            'mediumSpinnerLoadMaskTarget',
            'largeSpinnerLoadMaskTarget'
    ],

    renderTpl: [
        '<div id="{id}-inner" class="{baseCls}-inner">',
            '<div id="{id}-header" class="{baseCls}-header x-unselectable">',
                '<div id="{id}-lockedHeader" class="{baseCls}-header-locked"></div>',
                '<div id="{id}-normalHeader" class="{baseCls}-header-normal"><span id="{id}-headerScroll" class="{baseCls}-header-scroll"></span></div>',
            '</div>',
            '<div id="{id}-body" class="{baseCls}-body">',
                '<div class="{baseCls}-locked" id="{id}-lockedWrap"><table id="{id}-lockedTable" class="{baseCls}-table"><tbody id="{id}-lockedTableBody"></tbody></table><div class="{baseCls}-locked-scroll"><div class="{baseCls}-locked-scroll-inner"></div></div></div>',
                '<div class="{baseCls}-normal" id="{id}-normalWrap"><table id="{id}-normalTable" class="{baseCls}-table"><tbody id="{id}-tableBody"></tbody></table></div>',
            '</div>',
            '<div id="{id}-mediumSpinnerLoadMaskTarget"></div>',
            '<div id="{id}-largeSpinnerLoadMaskTarget"></div>',
        '</div>'
    ],

    initComponent() {
        this.data = this.data || [];
        this.columns ??= [];
        this.rows = [];

        this.setColumns(this.columns);

        this.callParent();
    },

    afterRender() {
        this.callParent();

        this.injectLoadMasks();
    },

    findByEl(array, dom) {
        if (!array || !dom) {
            return;
        }

        return array.find(item => item.el === dom);
    },

    fireCellEvent(ev) {
        var tr = ev.getTarget('.sa-grid-row'),
            td = ev.getTarget('.sa-grid-cell'),
            row = this.findByEl(this.rows, tr) || this.findByEl(this.lockedRows, tr),
            cell;

        if (!row) {
            return;
        }

        cell = this.findByEl(row.cells, td);

        if (!cell) {
            return;
        }

        this.fireEvent('cell:' + ev.type, this, td, row.data, cell.column);
    },

    fireColumnEvent(ev) {
        var el = ev.getTarget('.sa-grid-column'),
            column = this.findByEl(this.columns, el);

        this.fireEvent('column:' + ev.type, this, el, column);
    },

    generateRowUpdates(columns, rowIndex) {
        var row = this.data[rowIndex],
            cells, cls;

        cells = columns.map(column => {
            var text = row[column.dataIndex],
                cellCls = 'sa-grid-cell sa-grid-cell-' + (column.locked ? 'locked' : 'normal'),
                cell;

            if (column.cellCls) {
                cellCls += ' ' + column.cellCls;
            }

            if (column.align) {
                cellCls += ' sa-grid-cell-' + column.align;
            }

            cell = {
                cls: cellCls,
                column,
                text: text == null ? '' : (text + ''),
                width: column.width
            };

            return cell;
        });

        if (this.getRowCls) {
            cls = this.getRowCls(row);
        }

        cls = cls || '';

        if (rowIndex % 2) {
            cls += ' sa-grid-row-alt';
        }

        return {cells, data: row, cls};
    },

    getData() {
        return this.data;
    },

    getTotalWidth() {
        return this.totalColumnWidth + this.headerScroll.dom.clientWidth + 2; 
    },

    hasColumns() {
        return this.columns.length > 0;
    },

    initEvents() {
        var scrollLock;

        this.callParent();

        this.normalWrap.on({
            scroll: () => {
                var limits = this.cellScrollLimits || {},
                    scrollEl = this.normalWrap.dom,
                    scrollLeft = scrollEl.scrollLeft,
                    scrollTop = scrollEl.scrollTop;

                if (scrollLock === 'locked') {
                    scrollLock = null;
                }
                else {
                    scrollLock = 'normal';

                    this.normalHeader.dom.scrollLeft = scrollLeft;
                    this.lockedWrap.dom.scrollTop = scrollTop;
                }

                if (scrollTop < limits.minTop || scrollTop > limits.maxTop || scrollLeft < limits.minLeft || scrollLeft > limits.maxLeft) {
                    this.updateCells();
                }
            }
        });

        this.lockedWrap.on({
            scroll: () => {
                if (scrollLock === 'normal') {
                    scrollLock = null;

                    return;
                }

                scrollLock = 'locked';

                this.normalWrap.dom.scrollTop = this.lockedWrap.dom.scrollTop;
            }
        });

        this.body.on({
            delegate: '.sa-grid-cell',
            scope: this,

            click: this.fireCellEvent,
            mouseout: this.fireCellEvent,
            mouseover: this.fireCellEvent
        });

        this.header.on({
            delegate: '.sa-grid-column',
            scope: this,

            click: this.fireColumnEvent,
            mouseout: this.fireColumnEvent,
            mouseover: this.fireColumnEvent
        });
    },

    injectLoadMasks() {
        injectMask({spinnerSize: 'medium', renderTo: this.mediumSpinnerLoadMaskTarget});
        injectMask({spinnerSize: 'large', renderTo: this.largeSpinnerLoadMaskTarget});

        function injectMask({spinnerSize, renderTo}) {
            Ext.widget({
                xtype: 'load-mask',
                backgroundColor: 'transparent',
                cls: 'sa-report-grid-load-mask',
                renderTo,
                spinnerSize,
                zIndex: 10
            });
        }
    },

    onBoxReady() {
        this.callParent();

        this.updateColumns();
    },

    onResize() {
        this.callParent(arguments);

        this.updateCells();
    },

    refreshSpinnerSize() {
        var useMediumSpinner = this.rows.length < 5; 

        if (!this.rendered) {
            return;
        }

        this.mediumSpinnerLoadMaskTarget.setVisible(useMediumSpinner);
        this.largeSpinnerLoadMaskTarget.setVisible(!useMediumSpinner);
    },

    setColumns(columns) {
        var normalColumns = this.normalColumns = [],
            lockedColumns = this.lockedColumns = [],
            lockedForceColumns = this.lockedForceColumns = [],
            forceColumns = this.forceColumns = [],
            lockedWidth = 0,
            lockedForceWidth = 0,
            forceWidth = 0,
            allColumns = this.columns = [];

        columns.forEach(column => {
            column = Object.assign({
                encodeCells: true,
                encodeText: true,
                width: 100
            }, column);

            allColumns.push(column);

            if (column.locked) {
                lockedColumns.push(column);
                lockedWidth += column.width;

                if (column.forceRender) {
                    lockedForceColumns.push(column);
                    lockedForceWidth += column.width;
                }
            }
            else {
                normalColumns.push(column);

                if (column.forceRender) {
                    forceColumns.push(column);
                    forceWidth += column.width;
                }
            }
        });

        this.lockedWidth = lockedWidth;
        this.lockedForceWidth = lockedForceWidth;
        this.lockedTableWidth = lockedWidth + forceWidth;

        this.updateColumns();
        this.updateCells();
    },

    setData(data) {
        this.data = data;

        this.updateCells();
    },

    setLoading(loading) {
        if (loading !== this.loading) {
            this.loading = loading;

            this.refreshSpinnerSize();
            this.ifCls(loading, 'sa-grid-loading');
        }
    },

    updateCells() {
        if (!this.rendered) {
            return;
        }

        var normalTableBody = this.tableBody.dom,
            lockedTableBody = this.lockedTableBody.dom,
            data = this.data,
            normalColumns = this.normalColumns,
            lockedColumns = this.lockedColumns.concat(this.forceColumns),
            lockedCellCount = lockedColumns.length,
            totalWidth = 0,
            lockedWidth = this.lockedWidth,
            lockedTableWidth = this.lockedTableWidth,
            normalWrap = this.normalWrap,
            lockedWrap = this.lockedWrap,
            normalTable = this.normalTable,
            lockedTable = this.lockedTable,
            normalWrapDom = normalWrap.dom,
            scrollLeft = normalWrapDom.scrollLeft,
            scrollTop = normalWrapDom.scrollTop,
            scrollHeight = normalWrapDom.scrollHeight,
            scrollWidth = normalWrapDom.scrollWidth,
            clientHeight = normalWrapDom.clientHeight,
            clientWidth = normalWrapDom.clientWidth,
            availableHeight = this.getHeight() - 54, 
            availableWidth = this.getWidth() - lockedWidth - 2,
            constrain = Ext.Number.constrain,
            vScroll = constrain((scrollTop / (scrollHeight - clientHeight)) || 0, 0 , 1),
            hScroll = constrain((scrollLeft / (scrollWidth - clientWidth)) || 0, 0 , 1),
            totalRows = data.length,
            oldRows = this.rows,
            oldLockedRows = this.lockedRows || [],
            rows = [],
            lockedRows = [],
            rowHeight = this.rowHeight,
            lastScrollSizes = this.lastScrollSizes || {},
            columnGroup = [],
            visibleColumns = this.lockedForceColumns.slice(),
            lockedForceWidth = this.lockedForceWidth,
            maxScrollLeft, minScrollLeft, beforeHeight, afterHeight, visibleRowCount, rowsBefore,
            rowStartIndex, rowEndIndex, needsScrollX, needsScrollY, scrollSizes;

        scrollLeft = constrain(this.totalColumnWidth - availableWidth, 0, scrollLeft);

        normalColumns.forEach(column => {
            var width = column.width,
                newTotalWidth = totalWidth + width,
                columnVisible = totalWidth <= scrollLeft + availableWidth && scrollLeft <= newTotalWidth;

            if (columnVisible) {
                if (minScrollLeft == null) {
                    minScrollLeft = totalWidth;
                }

                maxScrollLeft = newTotalWidth;
            }

            if (columnVisible || column.forceRender) {
                flushDummyColumns();

                columnGroup.length = 0;

                visibleColumns.push(column);
            }
            else {
                columnGroup.push(column);
            }

            totalWidth = newTotalWidth;
        });

        flushDummyColumns();

        visibleRowCount = Math.min(totalRows, availableHeight / rowHeight);
        rowsBefore = (totalRows - visibleRowCount) * vScroll;

        rowStartIndex = Math.floor(rowsBefore);
        rowEndIndex = Math.ceil(rowsBefore + visibleRowCount);

        for (let rowIndex = rowStartIndex ; rowIndex < rowEndIndex ; ++rowIndex) {
            rows.push(this.generateRowUpdates(visibleColumns, rowIndex));

            if (lockedCellCount) {
                lockedRows.push(this.generateRowUpdates(lockedColumns, rowIndex));
            }
        }

        this.updateRows(oldRows, rows, normalTableBody);
        this.updateRows(oldLockedRows, lockedRows, lockedTableBody);

        this.rows = rows;
        this.lockedRows = lockedRows;

        beforeHeight = rowStartIndex * rowHeight;
        afterHeight = (totalRows - rowEndIndex) * rowHeight;

        normalTable.setStyle({
            marginBottom: afterHeight + 'px',
            marginLeft: (-lockedForceWidth) + 'px',
            marginTop: beforeHeight + 'px',
            width: (totalWidth + lockedForceWidth) + 'px'
        });

        lockedTable.setStyle({
            marginBottom: afterHeight + 'px',
            marginTop: beforeHeight + 'px',
            width: lockedTableWidth + 'px'
        });

        normalWrap.setStyle({
            marginLeft: lockedWidth + 'px',
            maxHeight: availableHeight + 'px',
            maxWidth: availableWidth + 'px'
        });

        lockedWrap.setStyle({
            maxHeight: availableHeight + 'px'
        });

        scrollSizes = {
            availableHeight,
            availableWidth,
            totalHeight: (beforeHeight || afterHeight) ? true : normalTable.dom.offsetHeight,
            totalWidth
        };

        if (Object.keys(scrollSizes).some(key => {
            return scrollSizes[key] !== lastScrollSizes[key];
        })) {
            this.lastScrollSizes = scrollSizes;

            needsScrollX = totalWidth > availableWidth;
            needsScrollY = beforeHeight + afterHeight;

            this.ifCls(needsScrollX, 'sa-grid-scroll-x');
            this.ifCls(needsScrollY, 'sa-grid-scroll-y');

            if (!needsScrollX) {
                needsScrollX = normalWrapDom.scrollWidth !== normalWrapDom.clientWidth;

                if (needsScrollX) {
                    this.addCls('sa-grid-scroll-x');
                }
            }

            if (!needsScrollY) {
                needsScrollY = normalWrapDom.scrollHeight !== normalWrapDom.clientHeight;

                if (needsScrollY) {
                    this.addCls('sa-grid-scroll-y');

                    if (!needsScrollX) {
                        needsScrollX = normalWrapDom.scrollWidth !== normalWrapDom.clientWidth;

                        if (needsScrollX) {
                            this.addCls('sa-grid-scroll-x');
                        }
                    }
                }
            }
        }

        scrollHeight = normalWrapDom.scrollHeight;
        scrollWidth = normalWrapDom.scrollWidth;
        clientHeight = normalWrapDom.clientHeight;
        clientWidth = normalWrapDom.clientWidth;

        this.cellScrollLimits = {
            maxLeft: maxScrollLeft - clientWidth,
            maxTop: beforeHeight + normalTable.dom.offsetHeight - clientHeight,
            minLeft: minScrollLeft,
            minTop: beforeHeight
        };

        normalWrapDom.scrollLeft = hScroll * (scrollWidth - clientWidth);
        normalWrapDom.scrollTop = vScroll * (scrollHeight - clientHeight);

        this.fireEvent('update:cells');

        function flushDummyColumns() {
            switch (columnGroup.length) {
                case 0:
                    break;
                case 1:
                    visibleColumns.push(columnGroup[0]);
                    break;
                default:
                    visibleColumns.push({
                        cellCls: 'sa-grid-dummy-cell',
                        width: Ext.Array.sum(Ext.Array.pluck(columnGroup, 'width'))
                    });
            }

            columnGroup.length = 0;
        }
    },

    updateColumnHeader(columns, header) {
        var nextEl = header.firstChild,
            totalWidth = 0,
            headerScroll = this.headerScroll.dom,
            htmlEncode = Ext.util.Format.htmlEncode;

        columns.forEach(column => {
            var el, width, text;

            if (!nextEl || nextEl === headerScroll) {
                el = document.createElement('div');

                if (nextEl) {
                    header.insertBefore(el, headerScroll);
                }
                else {
                    header.appendChild(el);
                }
            }
            else {
                el = nextEl;
                nextEl = el.nextSibling;
            }

            column.el = el;

            el.className = 'sa-grid-column ' + (column.cls || '');

            totalWidth += width = column.width;

            el.setAttribute('style', 'width: ' + width + 'px');

            text = column.text;

            text = text == null ? '' : (text + '');

            if (column.encodeText) {
                text = htmlEncode(text);
            }

            el.innerHTML = text;
        });

        while (nextEl && nextEl !== headerScroll) {
            let el = nextEl.nextSibling;

            Ext.removeNode(nextEl);

            nextEl = el;
        }

        return totalWidth;
    },

    updateColumns() {
        var lockedHeader = this.lockedHeader,
            normalHeader = this.normalHeader,
            lockedWidth = this.lockedWidth + 'px';

        if (!this.rendered) {
            return;
        }

        this.updateColumnHeader(this.lockedColumns, lockedHeader.dom);
        this.totalColumnWidth = this.updateColumnHeader(this.normalColumns, normalHeader.dom);

        lockedHeader.setStyle({
            width: lockedWidth
        });

        normalHeader.setStyle({
            marginLeft: lockedWidth
        });
    },

    updateRows(oldRows, rows, tableBody) {
        var rowCount = rows.length,
            cellCount = rowCount ? rows[0].cells.length : 0,
            doc = document,
            removeNode = cfg => Ext.removeNode(cfg.el);

        rows.forEach((row, rowIndex) => {
            var oldRow = oldRows[rowIndex],
                cells = row.cells,
                tr, oldCells;

            if (oldRow) {
                tr = oldRow.el;
                oldCells = oldRow.cells;
            }
            else {
                tr = doc.createElement('tr');

                oldCells = [];
                tableBody.appendChild(tr);
            }

            tr.className = 'sa-grid-row ' + row.cls;

            row.el = tr;

            for (let cellIndex = 0 ; cellIndex < cellCount ; ++cellIndex) {
                let cell = cells[cellIndex],
                    oldCell = oldCells[cellIndex],
                    encode = cell.column.encodeCells,
                    td, oldEncode;

                if (oldCell) {
                    td = oldCell.el;

                    oldEncode = oldCell.column.encodeCells;

                    if (oldCell.text !== cell.text || oldEncode !== encode) {
                        if (encode) {
                            if (oldEncode) {
                                td.firstChild.data = cell.text;
                            }
                            else {
                                while (td.firstChild) {
                                    Ext.removeNode(td.firstChild);
                                }

                                td.appendChild(doc.createTextNode(cell.text));
                            }
                        }
                        else {
                            td.innerHTML = cell.text;
                        }
                    }

                    if (oldCell.width !== cell.width) {
                        td.style.width = td.style.maxWidth = cell.width + 'px';
                    }

                    if (oldCell.cls !== cell.cls) {
                        td.className = cell.cls;
                    }
                }
                else {
                    td = doc.createElement('td');
                    td.className = cell.cls;

                    if (encode) {
                        td.appendChild(doc.createTextNode(cell.text));
                    }
                    else {
                        td.innerHTML = cell.text;
                    }

                    td.style.width = td.style.maxWidth = cell.width + 'px';

                    tr.appendChild(td);
                }

                cell.el = td;
            }

            oldCells.slice(cellCount).forEach(removeNode);
        });

        oldRows.slice(rowCount).forEach(removeNode);
    }
});